<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/132XMsL/media/FC-9781035831159.jpg?1718046561646" alt="This image is the cover for the book Katmeridou"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Katmeridou
      </h1>
      <p class="bookDescription body article font2">
        <p>Amid the gloomy backdrop of Glasgow’s streets, Noah strives to carve out a semblance of normalcy. His odyssey through secondary school is fraught with hurdles as he grapples with familial strife and the daily grind of academia. Determined to secure a future beyond the confines of his challenging circumstances, he is intent on performing well enough to land a respectable job. Noah’s sanctuary lies in the ivories of the piano, an instrument he has dedicated years to mastering. It’s more than a pastime: it’s his lifeline, providing solace in moments when the weight of the world bears down on him. When his school announces a music competition complete with a lucrative cash award, Noah sees a glimmer of hope. With the keys at his fingertips, he sets out to conquer the contest, a beacon of determination in a city that seems to have turned its back on him.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Atharva Patwardhan
      </h2>
      
      <p class="authorDescription body article">Atharva Patwardhan was born in Middlesbrough, England, in 2002. At the age of seven, he emigrated up to Scotland with his family. He completed his first novel, Katmeridou, at eighteen years old.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?f3504b1e